import { z } from 'zod';
import { PaymentEdgesModel } from './payment-edge';
import { PaymentNodesMetaModel } from './payment-node-meta';

export const PaymentGraphModel = z.object({
  nodesMeta: PaymentNodesMetaModel,
  edges: PaymentEdgesModel,
});
